import * as React from 'react'

function IconProfile(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 14a7.998 7.998 0 00-7.443 5.07C-.051 20.61 1.344 22 3 22h9.998c1.657 0 3.051-1.39 2.444-2.931A8.001 8.001 0 007.999 14z"
        fill="#fff"
      />
      <circle cx={8} cy={6} r={6} fill="#fff" />
    </svg>
  )
}

export default IconProfile
